<template>
<div class="page page_baocuo">
    <div class="filed">
        <div class="filed_title">评论</div>
        <div class="filed_nr">
            <van-field v-model="comment" :readonly="!canComment" type="textarea" placeholder="买家秀..." />
        </div>
    </div>
    <div class="filed">
        <div class="filed_title">图片</div>
        <div class="filed_nr">
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <!-- <img class="image" :src="item" /> -->
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" @click="showCommentImages(imglist,index)"/>
                    </div>
                    <div class="del" v-if="canComment" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone" v-if="canComment">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
    </div>
    <div class="actions" v-if="canComment">
        <div class="bottom_action" @click="tijiaoFun">提交评论</div>
    </div>
    <van-image-preview v-model="showImage" :images="imglist" :start-position="position" ref="attrPreView">
    </van-image-preview>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            madeId: this.$route.query.madeId, // 定制id
            orderId: this.$route.query.orderId, // 订单id
            comment: '', // 评论
            imglist: [], // 上传回显图片列表
            // url: 'http://timemap2.shanmuzhi.com',
            token: null,
            canComment: true,
            position: 0,
            showImage:false
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '定制评价',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getComment()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                // this.getData()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getComment()
        }
    },
    methods: {
        getComment() {
            var that = this
            var params = {
                token: this.token,
                order_num: this.orderId,
                page:1,
                size:100
            }
            this.$api.dingzhi.orderComment(params).then(res => {
                if (res.code == 200) {
                    var commentList = res.result
                    if (commentList && commentList.length > 0) {
                        var comment = commentList[0]
                        that.comment = comment.content
                        that.imglist = comment.attr
                        that.canComment = false
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        showCommentImages(attr,index) {
			for(let i in attr){
				attr[i] = this.imageUrl+attr[i];
			};
            this.showImage = true
            this.attrImages = attr
            this.position = index
        },
        // 提交
        tijiaoFun() {
            if (!this.comment) {
                this.$toast('评论不能为空');
                return
            }
            // 发表评论attr_type（0无1图片2视频）attr（图片，格式和商品评论一样）type（0定制入口1订单入口）order_num（订单号）
            var params = {
                token: this.token,
                order_num: this.orderId,
                content: this.comment,
                custom_made_id: this.madeId,
                type: 1
            }
            if (this.imglist && this.imglist.length > 0) {
                params.attr_type = 1
                params.attr = this.imglist
            }
            console.log(params)
            this.$api.dingzhi.comment(params).then(res => {
                if (res.code == 200) {
                    this.$toast('评论成功')
                    this.$router.back(-1);
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 图片上传 
        onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
